import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { selectAdversaries } from '../../reducers/adversaries'
import { useSelector } from 'react-redux'
import VisualizationNetworkPage from './visualization-network-page/VisualizationNetworkPage'
import VisualizationAptPage from './visualization-apt-page/VisualizationAptPage'
import VisualizationMalwarePage from './visualization-malware-page/VisualizationMalwarePage'
import VisualizationRawDataPage from './visualization-raw-data-page/VisualizationRawDataPage'

function VisualizationsWrapper() {
  const navigate = useNavigate()
  const { visualizationToShow } = useSelector(selectAdversaries)
  const [mapData, setMapData] = useState<object>({})

  useEffect(() => {
    const session = localStorage.getItem('session') as string
    if (session === '{}') {
      navigate('/login')
    }
    async function loadMapData() {
      try {
        const response = await fetch('https://code.highcharts.com/mapdata/custom/world.topo.json')
        const topology = await response.json()
        setMapData(topology)
      } catch (error) {
        console.error('Error loading map data:', error)
      }
    }

    loadMapData()
  }, [])

  const renderVisualizationPageComponent = () => {
    switch (visualizationToShow) {
      case 'networks':
        return <VisualizationNetworkPage mapData={mapData} />
      case 'malware':
        return <VisualizationMalwarePage mapData={mapData} />
      case 'apt':
        return <VisualizationAptPage mapData={mapData} />
      case 'raw':
        return <VisualizationRawDataPage />
      default:
        return <VisualizationNetworkPage mapData={mapData} />
    }
  }

  return (
    <>
      <div className="absolute top-18 left-52 rounded-tl-lg border-t border-l w-[calc(100%_-_208px)] h-[calc(100%_-_74px)] border-mainBorder bg-contentBackground p-9 overflow-y-auto">
        {visualizationToShow && renderVisualizationPageComponent()}
      </div>
    </>
  )
}

export default VisualizationsWrapper
